import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { ComboServices } from '../../services';
import { ComboCreateDishSelectPage } from '../combo-create-dish-select/combo-create-dish-select';
import { StaticsServices } from '../../../services/statics';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the ComboCreateTitlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-combo-create-title',
  templateUrl: 'combo-create-title.html',
})
export class ComboCreateTitlePage {
  type: any;
  public form: FormGroup;
  combo_uid: string;
  update_state: boolean = false;
  template_name: any;
  combo_name: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public translate: TranslateService,
    public comboServices: ComboServices,
    public staticsServices: StaticsServices,
    public analyticsServices: AnalyticsServices) {

    this.type = this.navParams.get('type');
    this.update_state = this.navParams.get('update');
    this.combo_uid = this.navParams.get('combo_uid');
    this.template_name = this.navParams.get('template_name');
    this.combo_name = this.navParams.get('combo_name');

    //tags
    if (this.update_state) {
      if (this.navParams.get('tags')) {
        this.comboServices.combo_tags = this.navParams.get('tags');
      } else {//caso combos existentes que no tendran tags
        this.comboServices.combo_tags = Array();
      }

    } else {
      this.comboServices.combo_tags = Array();
    }
    //
    if (this.update_state) {
      this.form = fb.group({
        reference: [String(this.navParams.get('reference')), Validators.compose([Validators.required])],
        title_es: [this.navParams.get('title_es')],
        title_ca: [this.navParams.get('title_ca')],
        title_en: [this.navParams.get('title_en')],
        title_de: [this.navParams.get('title_de')],
        title_it: [this.navParams.get('title_it')],
        title_fr: [this.navParams.get('title_fr')],
        subtitle_es: [this.navParams.get('subtitle_es')],
        subtitle_ca: [this.navParams.get('subtitle_ca')],
        subtitle_en: [this.navParams.get('subtitle_en')],
        subtitle_de: [this.navParams.get('subtitle_de')],
        subtitle_it: [this.navParams.get('subtitle_it')],
        subtitle_fr: [this.navParams.get('subtitle_fr')],
      });
    } else {
      this.form = fb.group({
        reference: ['', Validators.compose([Validators.required])],
        title_es: [''],
        title_ca: [''],
        title_en: [''],
        title_de: [''],
        title_it: [''],
        title_fr: [''],
        subtitle_es: [''],
        subtitle_ca: [''],
        subtitle_en: [''],
        subtitle_de: [''],
        subtitle_it: [''],
        subtitle_fr: [''],
      });
    }



  }

  submit() {
    if (this.form.value.reference != '') {
      //Update
      this.update();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-referencia-combo-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  update() {
    if (this.update_state) {//EDITAR
      this.globals.GAtrackView('Combo', 'Combo - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Combo', this.form.value.title_es);
      this.comboServices.afs.collection('menus').doc(this.combo_uid).update({
        'reference': String(this.form.value.reference),
        'title_es': this.form.value.title_es,
        'title_en': this.form.value.title_en,
        'title_fr': this.form.value.title_fr,
        'title_de': this.form.value.title_de,
        'title_it': this.form.value.title_it,
        'title_ca': this.form.value.title_ca,
        'subtitle_es': this.form.value.subtitle_es,
        'subtitle_en': this.form.value.subtitle_en,
        'subtitle_fr': this.form.value.subtitle_fr,
        'subtitle_it': this.form.value.subtitle_it,
        'subtitle_de': this.form.value.subtitle_de,
        'subtitle_ca': this.form.value.subtitle_ca,
        'updated_at': new Date(),
        'tags': this.comboServices.combo_tags,
        'tags_static': this.comboServices.combo_tags.toString(),
      }).then(() => {
        if (this.update_state) {
          //statics
          this.staticsServices.changeStateStaticWait(true);
          //pop
          this.navCtrl.pop();
        } else {
          this.openComboDishesSelect();
        }
      });
    } else {//CREAR
      this.globals.GAtrackView('Combo', 'Combo - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Combo', this.form.value.title_es);
      this.comboServices.afs.collection('menus').add({
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'style': this.type,
        'separator': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/separators%2Fseparador3.png?alt=media&token=1f0e9059-bd6a-49e8-a8e4-18c1e9ec3a11',
        'template': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates%2Ffons_mct_blanc.png?alt=media&token=15455e42-1097-4eb0-bb47-1d29ef9622d5',
        'logo_show': true,
        'caption_show': false,
        'enumerate': false,
        'footer_show': true,
        'footer_font_color': '#000',
        'footer_font_family': 'Arial',
        'footer_font_size': '18',
        'footer_text_align': 'center',
        'header_font_color': '#000',
        'header_font_family': 'Arial',
        'header_font_size': '18',
        'header_text_align': 'center',
        'image': '',
        'reference': String(this.form.value.reference),
        'title_es': this.form.value.title_es,
        'title_en': this.form.value.title_en,
        'title_fr': this.form.value.title_fr,
        'title_de': this.form.value.title_de,
        'title_it': this.form.value.title_it,
        'title_ca': this.form.value.title_ca,
        'subtitle_es': this.form.value.subtitle_es,
        'subtitle_en': this.form.value.subtitle_en,
        'subtitle_fr': this.form.value.subtitle_fr,
        'subtitle_it': this.form.value.subtitle_it,
        'subtitle_de': this.form.value.subtitle_fr,
        'subtitle_ca': this.form.value.subtitle_ca,
        'extra': 0,
        'price': 0,
        'extras_footer': [],
        'sections': this.getsections(),
        'created_at': new Date(),
        'digital_app': false,
        'template_name': 'rabassa',
        'tags': this.comboServices.combo_tags,
        'tags_static': this.comboServices.combo_tags.toString(),
        'type': 'combo'
      }).then(doc => {

        this.combo_uid = doc.id;

        if (this.update_state) {
          //statics
          this.staticsServices.changeStateStaticWait(true);
          //pop
          this.navCtrl.pop();
        } else {
          this.analyticsServices.trackingExp('crear combo', this.globals.tracking_exp['create_new_menu'], '');
          this.openComboDishesSelect();
        }
      });
    }
  }

  getsections() {
    var ret = {
      0: {
        dish: Array(),
        name: 'Todos'
      },
    }

    return ret;
  }

  openComboDishesSelect() {
    this.navCtrl.push(ComboCreateDishSelectPage, {
      type: this.type,
      section: '0',
      update: this.update_state,
      combo_uid: this.combo_uid,
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-title/combo-create-title.ts